import Image from 'next/image';
import { Avatar, Box, Typography } from '@mui/material';
import { useRouter } from 'next/router';

import { dateDiff } from '@/utils/formatDate';
import { useResponsive } from '@/hooks/useResponsive';
import capitalize from '@/utils/capitalize';
import Play from './Play';
import Dot from './Dot';
import Hash from './Hash';

export function VideoPost({ link, publication, user }): JSX.Element {
  const router = useRouter();
  const isMobile = useResponsive('down', 'md');
  const title = publication.title ? capitalize(publication.title) : '';

  return (
    <Box
      style={{
        cursor: 'pointer',
        borderRadius: '16px',
        overflow: 'hidden',
        position: 'relative',
      }}
      height={500}
      onClick={() => link && router.push(link.url)}
    >
      <Box
        sx={{
          position: 'absolute',
          top: isMobile ? '30%' : '50%',
          left: '50%',
          zIndex: 1,
          marginLeft: '-54px',
          marginTop: '-54px',
        }}
      >
        <Play />
      </Box>
      <Box
        sx={{
          backgroundColor: publication?.image.dominantColor,
          width: '100%',
          height: '100%',
        }}
      >
        <Image
          src={publication?.image?.url}
          alt={publication?.image?.alt}
          layout="fill"
          objectFit="cover"
        />
      </Box>
      <Box
        sx={{
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          position: 'absolute',
          bottom: '0',
          left: '0',
          right: '0',
        }}
      >
        <Box p={isMobile ? '20px 16px' : '44px 16px'}>
          <Typography variant="h3" component="a" color="#FFFFFF">
            {title}
          </Typography>

          <Box
            display="flex"
            flexDirection={isMobile ? 'column' : 'row'}
            alignItems={isMobile ? 'flex-start' : 'center'}
            gap={2}
          >
            <Box display="flex" alignItems="center" gap={2}>
              <Avatar
                alt={user?.firstName}
                src={user?.image?.url}
                sx={{ width: 30, height: 30 }}
              />

              <Typography variant="body2" component="span" color="#FFFFFF">
                {user?.firstName || 'Author'}
              </Typography>

              <Box display="flex" alignItems="center" gap={2}>
                <Dot />
                <Hash />
                <Typography
                  sx={{ textDecoration: 'underline' }}
                  variant="body2"
                  component="a"
                  color="#FFFFFF"
                >
                  {link.label}
                </Typography>
                {!isMobile ? <Dot /> : null}
              </Box>
            </Box>

            <Typography variant="body2" color="#FFFFFF">
              {dateDiff(publication?.updatedAt || publication?.createdAt)}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
